var map = {
	"./distribution": [
		"g9i5",
		0,
		2
	],
	"./distribution/": [
		"g9i5",
		0,
		2
	],
	"./distribution/commission": [
		"wrMg",
		0,
		22
	],
	"./distribution/commission.vue": [
		"wrMg",
		0,
		22
	],
	"./distribution/commissionTop": [
		"AIUr",
		0,
		17
	],
	"./distribution/commissionTop.vue": [
		"AIUr",
		0,
		17
	],
	"./distribution/index": [
		"g9i5",
		0,
		2
	],
	"./distribution/index.vue": [
		"g9i5",
		0,
		2
	],
	"./distribution/inviterOrders": [
		"rnur",
		0,
		10
	],
	"./distribution/inviterOrders.vue": [
		"rnur",
		0,
		10
	],
	"./distribution/inviterTop": [
		"YydT",
		0,
		21
	],
	"./distribution/inviterTop.vue": [
		"YydT",
		0,
		21
	],
	"./distribution/inviters": [
		"2rJG",
		0,
		20
	],
	"./distribution/inviters.vue": [
		"2rJG",
		0,
		20
	],
	"./distribution/share": [
		"PeUN",
		8
	],
	"./distribution/share.vue": [
		"PeUN",
		8
	],
	"./distribution/withdrawal": [
		"ulog",
		0,
		12
	],
	"./distribution/withdrawal.vue": [
		"ulog",
		0,
		12
	],
	"./help": [
		"IPaL",
		5
	],
	"./help/": [
		"IPaL",
		5
	],
	"./help/content": [
		"YhW2",
		15
	],
	"./help/content.vue": [
		"YhW2",
		15
	],
	"./help/index": [
		"IPaL",
		5
	],
	"./help/index.vue": [
		"IPaL",
		5
	],
	"./home": [
		"FP3a",
		0,
		3
	],
	"./home/": [
		"FP3a",
		0,
		3
	],
	"./home/banners": [
		"j+Mz",
		0,
		14
	],
	"./home/banners.vue": [
		"j+Mz",
		0,
		14
	],
	"./home/index": [
		"FP3a",
		0,
		3
	],
	"./home/index.vue": [
		"FP3a",
		0,
		3
	],
	"./home/works": [
		"5YNj",
		16
	],
	"./home/works.vue": [
		"5YNj",
		16
	],
	"./load": [
		"6kW0"
	],
	"./load/": [
		"6kW0"
	],
	"./load/index": [
		"6kW0"
	],
	"./load/index.vue": [
		"6kW0"
	],
	"./order": [
		"0wiy",
		0,
		1
	],
	"./order/": [
		"0wiy",
		0,
		1
	],
	"./order/detail": [
		"IeHp",
		0,
		11
	],
	"./order/detail.vue": [
		"IeHp",
		0,
		11
	],
	"./order/index": [
		"0wiy",
		0,
		1
	],
	"./order/index.vue": [
		"0wiy",
		0,
		1
	],
	"./order/pay": [
		"Meru",
		0,
		13
	],
	"./order/pay.vue": [
		"Meru",
		0,
		13
	],
	"./shop": [
		"aiZS",
		6
	],
	"./shop/": [
		"aiZS",
		6
	],
	"./shop/goods": [
		"PUul",
		0,
		19
	],
	"./shop/goods.vue": [
		"PUul",
		0,
		19
	],
	"./shop/goodslist": [
		"bY7s",
		0,
		7
	],
	"./shop/goodslist.vue": [
		"bY7s",
		0,
		7
	],
	"./shop/index": [
		"aiZS",
		6
	],
	"./shop/index.vue": [
		"aiZS",
		6
	],
	"./user": [
		"m2Or",
		0,
		4
	],
	"./user/": [
		"m2Or",
		0,
		4
	],
	"./user/address": [
		"3Htw",
		0,
		9
	],
	"./user/address.vue": [
		"3Htw",
		0,
		9
	],
	"./user/edit": [
		"7703",
		0,
		18
	],
	"./user/edit.vue": [
		"7703",
		0,
		18
	],
	"./user/index": [
		"m2Or",
		0,
		4
	],
	"./user/index.vue": [
		"m2Or",
		0,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5BXs";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*$
// module id = 5BXs
// module chunks = 24